exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".emulator_view {\n  display: flex;\n  margin: 20px; }\n", "", {"version":3,"sources":["/Users/sleroux/development/chip8-js/src/components/Emulator/src/components/Emulator/Emulator.scss"],"names":[],"mappings":"AAAA;EACI,cAAa;EACb,aAAY,EACf","file":"Emulator.scss","sourcesContent":[".emulator_view {\n    display: flex;\n    margin: 20px;\n}\n"],"sourceRoot":""}]);

// exports
